import { Component } from 'react';
import PropTypes from 'prop-types';
import ImageGallery from './Galleries/Image/PerformanceImageGallery';
import VideoGallery from './Galleries/Video/PerformanceVideoGallery';

export default class PerformanceGalleriesSwitch extends Component {
  constructor(props) {
    super(props);

    this.galleryTypes = {
      images: 'images',
      videos: 'videos',
    };

    this.state = {
      activeGallery: this.galleryTypes.images,
    };

    this.handleSwitch = this.handleSwitch.bind(this);
  }

  handleSwitch(galleryType) {
    if (galleryType === this.state.activeGallery) return;

    this.setState({
      activeGallery: galleryType,
    });
  }

  render() {
    const { activeGallery } = this.state;
    const { images, videos } = this.props;

    const renderImages =
      images.length > 0 && (activeGallery === 'images' || videos.length === 0);

    const renderVideos =
      videos.length > 0 && (activeGallery === 'videos' || images.length === 0);

    const showSwitch = images.length > 0 && videos.length > 0;

    return (
      <div>
        {showSwitch && (
          <div className="media-gallery__switches container">
            <button
              className="media-gallery__switch-button"
              data-active-gallery={activeGallery === 'images'}
              type="button"
              onClick={() => this.handleSwitch(this.galleryTypes.images)}
            >
              imagens
            </button>
            <button
              className="media-gallery__switch-button"
              data-active-gallery={activeGallery === 'videos'}
              type="button"
              onClick={() => this.handleSwitch(this.galleryTypes.videos)}
            >
              vídeos
            </button>
          </div>
        )}

        {renderImages && <ImageGallery images={images} />}
        {renderVideos && <VideoGallery videos={videos} />}
      </div>
    );
  }
}

PerformanceGalleriesSwitch.defaultProps = {
  videos: [],
  images: [],
};

PerformanceGalleriesSwitch.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      main_image: PropTypes.string,
      thumb_image: PropTypes.string,
    }),
  ),
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      main_image: PropTypes.string,
      thumb_image: PropTypes.string,
    }),
  ),
};
